export default __webpack_public_path__ + "static/media/flag-France.8a72b2eb.svg";